import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Popover, Tooltip } from 'antd';
import { MoreMenu } from 'datastake-daf/dist/components';
import CoordinatesViewer from './coordinatesViewer';
import { snakeCaseToTitleCase } from '../../../helpers/StringHelper';

const ViewsBy = styled.div`
  min-width: 250px;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 400px;

  p {
    font-size: 0.9rem;
    margin-bottom: 0px;
  }
`

export const getColumns = (view, edit, setEntityData, selectOptions = {}, t = (s) => s) => {
  const administrativeLevelCols = [
    {
      title: t('name'),
      dataIndex: 'name',
      key: 'name',
      primarySearch: true,
      search: true,
    },
    {
      title: t('Level'),
      dataIndex: 'levelName',
      key: 'level',
      search: true,
      inheritFromFirstItem: true,
      render: (name, all) => name || snakeCaseToTitleCase(all.level || ''),
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      search: true,
      render: (v) => {
        const { country = [] } = selectOptions;
        const item = country.find(i => i.value === v);
        return item ? item.label : v;
      },
    },
    // {
    //   title: 'Id',
    //   dataIndex: 'id',
    //   key: 'id',
    //   noMerge: true,
    // },
    {
      title: t('Adm Level 1'),
      dataIndex: 'administrativeLevel1Name',
      key: 'administrativeLevel1',
    },
    {
      width: 60,
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (i, item) => {
        const items = [
          {
            key: "edit",
            onClick: () => {
              setEntityData(item);
              edit(true);
            },
            label: t('Edit'),
          },
          !!item.coordinates ? {
            key: "viewOnMap",
            label: (
              <Popover
                trigger="click"
                content={<CoordinatesViewer coordinates={item.coordinates} />}
                placement="leftTop"
              >
                {t('View on map')}
              </Popover>
            )
          } : null,
        ]

        return <MoreMenu items={items} />;
      },
      search: false,
    },
  ];

  const viewsByCol = {
    title: t('Used By'),
    dataIndex: 'sources',
    key: 'sources',
    tableOnly: true,
    render: (val = []) => {
      return val.length ? (
        <Popover
          placement="left"
          content={(
            <ViewsBy>
              {val.map((c, i) => (
                <p key={`${c.id}-${i}`}>
                  {c.name}
                </p>
              ))}
            </ViewsBy>
          )}
        >
          <div className="clickable-link">
            {val.length}
          </div>
        </Popover>
      ) : (
        <div className="clickable-link">
          {val.length}
        </div>
      );
    }
  };

  const administrativeLevel1Cols = [
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
      primarySearch: true,
      search: true,
    },
    {
      title: t('Level'),
      dataIndex: 'levelName',
      key: 'level',
      search: true,
      inheritFromFirstItem: true,
    },
    {
      title: t('Country'),
      dataIndex: 'country',
      key: 'country',
      search: true,
      render: (v) => {
        const { country = [] } = selectOptions;
        const item = country.find(i => i.value === v);
        return item ? item.label : v;
      },
    },
    // {
    //   title: 'Id',
    //   dataIndex: 'id',
    //   key: 'id',
    //   disabled: true,
    //   noMerge: true,
    // },
    {
      width: 60,
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (i, item) => {
        const items = [
          {
            key: "edit",
            onClick: () => {
              setEntityData(item);
              edit(true);
            },
            label: t('Edit'),
          },
          !!item.coordinates ? {
            key: "viewOnMap",
            label: (
              <Popover
                trigger="click"
                content={<CoordinatesViewer coordinates={item.coordinates} />}
                placement="leftTop"
              >
                {t('View on map')}
              </Popover>
            )
          } : null,
        ]

        return <MoreMenu items={items} />;
      },
      search: false,
    },
  ];

  const cols = {
    stakeholders: [
      {
        title: t('ID'),
        dataIndex: 'datastakeId',
        key: 'datastakeId',
        search: true,
        inheritFromFirstItem: true,
        ellipsis: true,
        width: 145,
      },
      {
        title: t('Name'),
        dataIndex: 'name',
        key: 'name',
        primarySearch: true,
        search: true,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Country'),
        dataIndex: 'country',
        key: 'country',
        search: true,
        ellipsis: true,
        render: (v) => {
          const { country = [] } = selectOptions;
          const item = country.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      {
        title: t('Category'),
        dataIndex: 'category',
        key: 'category',
        search: true,
        ellipsis: true,
        render: (v) => {
          const { category = [] } = selectOptions;
          const item = category.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      {
        title: t('Sub category'),
        dataIndex: 'subCategory',
        key: 'subCategory',
        search: true,
        ellipsis: true,
        render: (v) => {
          const { subCategory = [] } = selectOptions;
          const item = subCategory.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      viewsByCol,
      {
        width: 60,
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (i, item) => {
          const items = [
            {
              key: "edit",
              onClick: () => {
                setEntityData(item);
                edit(true);
              },
              label: t('Edit'),
            },
          ]

          return <MoreMenu items={items} />;
        },
        search: false,
      },
      {
        title: t('Economic Sector'),
        dataIndex: 'economicSector',
        key: 'economicSector',
        onlyMerge: true,
      },
    ],
    locations: [
      {
        title: t('ID'),
        dataIndex: 'datastakeId',
        key: 'datastakeId',
        search: true,
        ellipsis: true,
        width: 145,
        // render: (id) => {
        //   return <NavLink className="projectLink" to={`/app/admin/update/locations/${id}`}>
        //     {id}
        //   </NavLink>
        // },
        mergePos: 0,
        inheritFromFirstItem: true,
      },
      {
        title: t('Name'),
        dataIndex: 'locationName',
        key: 'locationName',
        search: true,
        primarySearch: true,
        mergePos: 1,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Category'),
        dataIndex: 'category',
        key: 'category',
        search: true,
        mergePos: 5,
        ellipsis: true,
        render: (v) => {
          const { category = [] } = selectOptions;
          const item = category.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      {
        title: t('Country'),
        dataIndex: 'country',
        key: 'country',
        search: true,
        ellipsis: true,
        mergePos: 2,
        render: (v) => {
          const { country = [] } = selectOptions;
          const item = country.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      {
        title: t('Province'),
        dataIndex: 'administrativeLevel1Name',
        key: 'administrativeLevel1',
        search: true,
        mergePos: 3,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Territory'),
        dataIndex: 'administrativeLevel2Name',
        key: 'administrativeLevel2',
        search: true,
        mergePos: 4,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      viewsByCol,
      {
        width: 60,
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (i, item) => {
          const items = [
            {
              key: "edit",
              onClick: () => {
                setEntityData(item);
                edit(true);
              },
              label: t('Edit'),
            },
          ]

          return <MoreMenu items={items} />;
        },
        search: false,
      },
    ],
    lir: [
      {
        title: t('ID'),
        dataIndex: 'datastakeId',
        key: 'datastakeId',
        search: true,
        // render: (id) => {
        //   return <NavLink className="projectLink" to={`/app/admin/update/lir/${id}`}>
        //     {id}
        //   </NavLink>
        // },
        inheritFromFirstItem: true,
        ellipsis: true,
        width: 145,
      },
      {
        title: t('Name'),
        dataIndex: 'name',
        key: 'name',
        primarySearch: true,
        search: true,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Country'),
        dataIndex: 'country',
        key: 'country',
        search: true,
        ellipsis: true,
        render: (v) => {
          const { country = [] } = selectOptions;
          const item = country.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      {
        title: t('Category'),
        dataIndex: 'category',
        key: 'category',
        search: true,
        ellipsis: true,
        render: (v) => {
          const { category = [] } = selectOptions;
          const item = category.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      {
        title: t('Sub category'),
        dataIndex: 'subCategory',
        key: 'subCategory',
        search: true,
        ellipsis: true,
        render: (v) => {
          const { subCategory = [] } = selectOptions;
          const item = subCategory.find(i => i.value === v);
          const _v = item ? item.label : v;
          return <Tooltip title={_v}>{_v}</Tooltip>;
        },
      },
      viewsByCol,
      {
        width: 60,
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (i, item) => {
          const items = [
            {
              key: "edit",
              onClick: () => {
                setEntityData(item);
                edit(true);
              },
              label: t('Edit'),
            },
          ]

          return <MoreMenu items={items} />;
        },
        search: false,
      },
      {
        title: t('Other Category'),
        dataIndex: 'otherCategory',
        key: 'otherCategory',
        onlyMerge: true,
      },
    ],
    scp: [
      {
        title: t('ID'),
        dataIndex: 'datastakeId',
        key: 'datastakeId',
        search: true,
        // render: (id) => {
        //   return <NavLink className="projectLink" to={`/app/admin/update/scp/${id}`}>
        //     {id}
        //   </NavLink>
        // },
        inheritFromFirstItem: true,
        ellipsis: true,
        width: 145,
      },
      {
        title: t('Name'),
        dataIndex: 'name',
        key: 'name',
        search: true,
        primarySearch: true,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Country'),
        dataIndex: 'countryName',
        key: 'country',
        search: true,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Category'),
        dataIndex: 'categoryName',
        key: 'category',
        search: true,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Sub category'),
        dataIndex: 'subCategoryName',
        key: 'subCategory',
        search: true,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      viewsByCol,
      {
        width: 60,
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (i, item) => {
          const items = [
            {
              key: "edit",
              onClick: () => {
                setEntityData(item);
                edit(true);
              },
              label: t('Edit'),
            },
          ]

          return <MoreMenu items={items} />;
        },
        search: false,
      },
      {
        title: t('Economic Sector'),
        dataIndex: 'economicSector',
        key: 'economicSector',
        onlyMerge: true,
      },
    ],
    events: [
      {
        title: t('ID'),
        dataIndex: 'datastakeId',
        key: 'datastakeId',
        search: true,
        inheritFromFirstItem: true,
        ellipsis: true,
        width: 145,
      },
      {
        title: t('Title'),
        dataIndex: 'eventTitle',
        key: 'eventTitle',
        primarySearch: true,
        search: true,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Type'),
        dataIndex: 'typeOfEvent',
        key: 'typeOfEvent',
        search: true,
        ellipsis: true,
        render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      },
      {
        title: t('Date'),
        dataIndex: 'dateOfEvent',
        key: 'dateOfEvent',
        search: true,
        ellipsis: true,
        width: 125,
        render: (date, all) => {
          const title = date ? moment(date).format('DD MMM YYYY') : '';
          return <Tooltip title={title}>{title}</Tooltip>
        },
      },
      {
        title: t('Country'),
        dataIndex: 'country',
        key: 'country',
        search: true,
        ellipsis: true,
        render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      },

      viewsByCol,
      {
        width: 60,
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (i, item) => {
          const items = [
            {
              key: "edit",
              onClick: () => {
                setEntityData(item);
                edit(true);
              },
              label: t('Edit'),
            },
          ]

          return <MoreMenu items={items} />;
        },
        search: false,
      },
      {
        title: t('Economic Sector'),
        dataIndex: 'economicSector',
        key: 'economicSector',
        onlyMerge: true,
      },
    ],
    scl: [
      {
        title: t('ID'),
        dataIndex: 'datastakeId',
        key: 'datastakeId',
        search: true,
        // render: (id) => {
        //   return <NavLink className="projectLink" to={`/app/admin/update/scl/${id}`}>
        //     {id}
        //   </NavLink>
        // },
        mergePos: 0,
        inheritFromFirstItem: true,
        ellipsis: true,
        width: 145,
      },
      {
        title: t('name'),
        dataIndex: 'locationName',
        key: 'locationName',
        search: true,
        primarySearch: true,
        mergePos: 1,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Category'),
        dataIndex: 'categoryName',
        key: 'category',
        search: true,
        mergePos: 6,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Country'),
        dataIndex: 'countryName',
        key: 'country',
        search: true,
        mergePos: 2,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Province'),
        dataIndex: 'administrativeLevel1Name',
        key: 'administrativeLevel1',
        search: true,
        mergePos: 3,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      {
        title: t('Territory'),
        dataIndex: 'administrativeLevel2Name',
        key: 'administrativeLevel2',
        search: true,
        mergePos: 4,
        ellipsis: true,
        render: (v) => <Tooltip title={v}>{v}</Tooltip>,
      },
      viewsByCol,
      {
        width: 60,
        title: '',
        dataIndex: 'action',
        key: 'action',
        render: (i, item) => {
          const items = [
            {
              key: "edit",
              onClick: () => {
                setEntityData(item);
                edit(true);
              },
              label: t('Edit'),
            },
          ]

          return <MoreMenu items={items} />;
        },
        search: false,
      },
    ],
    administrativeLevel1: administrativeLevel1Cols,
    administrativeLevel2: administrativeLevelCols,
    administrativeLevel3: administrativeLevelCols,
    administrativeLevel4: administrativeLevelCols,
    administrativeLevel5: administrativeLevelCols,
    administrativeLevel6: administrativeLevelCols,
    administrativeLevel7: administrativeLevelCols,
    administrativeLevel8: administrativeLevelCols,
    administrativeLevel9: administrativeLevelCols,
    administrativeLevel10: administrativeLevelCols,
    undefined: [
      {
        title: t('ID'),
        dataIndex: 'datastakeId',
        key: 'datastakeId',
        search: true,
      },
    ],
  };
  return cols[view || 'undefined'];
}
